import locales from "./locales/locales";
import router from './routes/routes'

export const ParametersModule = {
	name: 'parameters',
	routes: router,
	locales: locales,
}